// extracted by mini-css-extract-plugin
module.exports = {"SubBox":"SubBox_SubBox__1E7ZZ"};